import {inject, ModuleWithProviders, NgModule, provideAppInitializer} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TenantService} from "./tenant/tenant.service";
import {AUTH_CONFIG, AuthConfiguration} from "./auth-configuration";
import {OAuthModule, OAuthStorage} from "angular-oauth2-oidc";
import {AuthConfigService} from "./auth/auth-config.service";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        OAuthModule.forRoot()
    ],
    providers: [
        TenantService,
        {provide: OAuthStorage, useValue: localStorage},
    ],
    exports: []
})
export class AuthModule {

    static forRoot(config: AuthConfiguration): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                TenantService,
                {provide: AUTH_CONFIG, useValue: config},
                provideAppInitializer(() => {
                    const initializerFn = ((authConfigService: AuthConfigService) => () => authConfigService.setConfig(config))(inject(AuthConfigService));
                    return initializerFn();
                })
            ]
        };
    }
}
